<div class="page-header">
  <h1>Rôles et droits</h1>
</div>

<div class="page-body">
  <div class="role-list">
    @for (role of roles; track role) {
    <div class="card role-card">
      <div class="role-card-header">
        <span class="role-name">{{ role.name }}</span>
        <span class="role-user-count">{{ role.users.length }} utilisateur(s)</span>
      </div>

      @if (user.isRoot() && role.operations?.length > 0) {
      <div class="role-operations">
        @for (op of role.operations; track op) {
        <span class="badge rounded-pill operation-chip">{{ op.name }}</span>
        }
      </div>
      }

      @if (role.users.length > 0) {
      <div class="role-users">
        @for (u of role.users; track u) {
        <a class="role-user-link" [routerLink]="[u.id]">{{ u.fullname }}</a>
        }
      </div>
      } @else {
      <p class="role-empty">Aucun utilisateur avec ce rôle.</p>
      }
    </div>
    }
  </div>
</div>
